<template>
    <v-dialog
    v-model="dialog"
      width="auto">
      <v-alert text="Для работы сайта и его взаимодействия с пользователями мы используем файлы cookie и локальное хранилище браузера. 
        Продолжая работу с сайтом, Вы разрешаете использование cookie-файлов и локального хранилища браузера. 
        Вы всегда можете отключить файлы cookie в настройках Вашего браузера." type="info"  >
       <v-row>
        <v-spacer></v-spacer>
        <v-col></v-col>
       
        <AppButton @click="acceptCookies" class="banner__button ma-4">Принять</AppButton>
    </v-row>
</v-alert>
       
 
      
    </v-dialog>
  </template>
  
  <script>
  import { ref, onMounted } from "vue";
  import AppButton from "@/elements/AppButton.vue";

  export default {
    name: "CookieBanner",
    components: {
    AppButton
  },
    setup() {
    const dialog = ref(false);
   
    function acceptCookies() {
        dialog.value = false;
        localStorage.setItem("acceptCookies",true);
      }
      onMounted(() => {
        if(localStorage.getItem("acceptCookies")){
            if (localStorage.getItem("acceptCookies")=="true"){
                dialog.value = false;
            } else {
                dialog.value = true; 
            }
        } else {
            dialog.value = true;
        }
    });
      return {dialog,
        acceptCookies
      }
    },



  }
  
  </script>
  
  <style lang="scss">
  .banner {
    &__button {
    margin: 10px;
    border:  dashed;
    border-radius: 4px;
    }
  }
  </style>